import { Paper, ListItem, ListItemIcon, ListItemText, Box, Typography, Stack } from "@mui/material";
import { FieldIcon } from "../Field/FieldIcon";
import { stringStartsWithVowel } from "../../utils";
import { useTranslation } from "react-i18next";
interface Props {
  fieldName: string;
  fieldType: string;
  description: string;
  commonUses: string[];
  proTip: string;
}
export const TooltipBody = ({
  fieldName,
  fieldType,
  description,
  commonUses,
  proTip
}: Props) => {
  const {
    t
  } = useTranslation();
  const headerText = stringStartsWithVowel(fieldName) ? t("schema.tooltipWhatIsAnField", {
    fieldName
  }) : t("schema.tooltipWhatIsAField", {
    fieldName
  });
  return <Paper sx={{
    width: "420px"
  }} data-sentry-element="Paper" data-sentry-component="TooltipBody" data-sentry-source-file="TooltipBody.tsx">
      <ListItem sx={{
      py: 1,
      px: 2,
      borderBottom: 1,
      borderColor: "border"
    }} data-sentry-element="ListItem" data-sentry-source-file="TooltipBody.tsx">
        <ListItemIcon sx={{
        minWidth: "36px"
      }} data-sentry-element="ListItemIcon" data-sentry-source-file="TooltipBody.tsx">
          <FieldIcon type={fieldType} data-sentry-element="FieldIcon" data-sentry-source-file="TooltipBody.tsx" />
        </ListItemIcon>
        <ListItemText primary={fieldName} secondary={t("schema.faqBadge")} slotProps={{
        primary: {
          fontWeight: 700,
          color: "text.primary",
          variant: "body2"
        },
        secondary: {
          variant: "body3"
        }
      }} sx={{
        my: 0.5
      }} data-sentry-element="ListItemText" data-sentry-source-file="TooltipBody.tsx" />
      </ListItem>
      <Stack data-sentry-element="Stack" data-sentry-source-file="TooltipBody.tsx">
        <Box px={2} py={1} data-sentry-element="Box" data-sentry-source-file="TooltipBody.tsx">
          <Typography variant="body2" fontWeight="700" pb={0.5} data-sentry-element="Typography" data-sentry-source-file="TooltipBody.tsx">
            {headerText}
          </Typography>
          <Typography variant="body3" color="text.secondary" whiteSpace="pre-line" fontWeight={400} data-sentry-element="Typography" data-sentry-source-file="TooltipBody.tsx">
            {description}
          </Typography>
        </Box>
        <Box px={2} py={1} data-sentry-element="Box" data-sentry-source-file="TooltipBody.tsx">
          <Typography variant="body2" fontWeight="700" pb={0.5} data-sentry-element="Typography" data-sentry-source-file="TooltipBody.tsx">
            {t("schema.commonUses")}
          </Typography>
          <Box pl={3} component="ul" data-sentry-element="Box" data-sentry-source-file="TooltipBody.tsx">
            {commonUses.map((string, index) => <Typography variant="body3" color="text.secondary" component="li" key={index} sx={{
            display: "list-item"
          }}>
                {string}
              </Typography>)}
          </Box>
        </Box>
        {fieldType === "repeater" && <Box px={2} py={1}>
            <Typography variant="body2" fontWeight="700" pb={0.5}>
              {t("schema.howIsDataStored")}
            </Typography>
            <Typography fontWeight={400} variant="body3" color="text.secondary" mb={0.5}>
              {t("schema.repeaterDataStorageDescription")}
            </Typography>
            <Typography fontWeight={400} variant="body3" color="text.secondary">
              {'e.g. [{quote: "ACME has solved all my needs", name: "Jane Doe"}, {quote: "I love ACME!", name: "John Doe"}]'}
            </Typography>
          </Box>}
        <Box px={2} py={1} data-sentry-element="Box" data-sentry-source-file="TooltipBody.tsx">
          <Typography variant="body2" fontWeight="700" pb={0.5} data-sentry-element="Typography" data-sentry-source-file="TooltipBody.tsx">
            {t("schema.proTip")}
          </Typography>
          <Typography fontWeight={400} variant="body3" color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="TooltipBody.tsx">
            {proTip}
          </Typography>
        </Box>
      </Stack>
    </Paper>;
};